import { createStyles, Theme } from '@material-ui/core'

export const landingKpiCardStyles = (theme: Theme) =>
  createStyles({
    root: {
      minHeight: '15rem',
      display: 'flex',
      flexGrow: 1,
      flexDirection: 'column',
      marginBottom: theme.spacing(2)
    },
    container: {
      flexGrow: 1,
      width: '100%',
      display: 'flex',
      flexDirection: 'column'
    },
    contentWrapper: {
      display: 'flex',
      flexDirection: 'row',
      flexGrow: 1,
      alignItems: 'stretch'
    },
    leftContent: {
      flex: 2,
      marginRight: theme.spacing(4),
      height: 'auto',
      display: 'flex',
      flexDirection: 'column'
    },
    noLeftMargin: {
      marginRight: 0
    },
    rightContent: {
      flex: 9,
      marginTop: 0,
      height: 'auto',
      alignSelf: 'stretch',
      display: 'flex',
      flexDirection: 'column'
    },
    dividerVertical: {
      alignSelf: 'stretch',
      margin: theme.spacing(0, 2)
    },
    dividerHorizontal: {
      height: '1px',
      width: '100%',
      margin: theme.spacing(2, 0)
    },
    responsiveLeftContent: {
      marginRight: 0
    },
    responsiveRightContent: {
      marginTop: theme.spacing(2)
    },
    responsiveTitle: {
      marginLeft: 'auto',
      textAlign: 'center'
    },
    title: {
      marginLeft: theme.spacing(2),
      textAlign: 'left'
    }
  })
